import { currentStoreLocatorSX } from '@/components/content/FacetNavigation/styles/currentStoreLocator';
import { openLocateStoreMenu } from '@/components/content/Header/parts/LocateStore/utils/locateStoreEvents';
import { storeLocatorHeaderInfoStoreNameSX } from '@/components/content/StoreLocator/styles/StoreLocatorHeaderInfo/storeLocatorHeaderInfoStyles';
import DynamicIcon from '@/components/icons/DynamicIcon';
import { useDefaultStore } from '@/data/Content/DefaultStore';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { MATERIAL_SYMBOL_ICONS } from 'shared/custom/constants/commonConstants';

export const CurrentStoreLocator = () => {
	const { storeData } = useDefaultStore();
	const theme = useTheme();

	if (!storeData) return null;

	return (
		<Box sx={currentStoreLocatorSX} onClick={openLocateStoreMenu}>
			<DynamicIcon
				variant="filled"
				name={MATERIAL_SYMBOL_ICONS.locationOn}
				size={16}
				color={theme.palette.grey[500]}
			/>
			<Box>
				<Typography
					variant="body2"
					sx={storeLocatorHeaderInfoStoreNameSX}
				>{`${storeData?.storeName}, ${storeData?.shortName}`}</Typography>
			</Box>
		</Box>
	);
};
